import { render } from "./RouterLink.vue?vue&type=template&id=404fd8bb"
import script from "./RouterLink.vue?vue&type=script&lang=js"
export * from "./RouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__